export default {
  namespaced: true,
  state: {
    id: "",
    minimized: false
  },
  getters: {
    opdrachtData(state, getters, rootState) {
      return rootState.opdrachten.find(e => e.id === state.id)
    }
  },
  mutations: {
    setId: (state, payload) => {
      state.id = payload
      state.minimized = false
    },
    close: state => {
      state.id = ""
    },
    toggleMinimize: state => (state.minimized = !state.minimized)
  },
  actions: {}
}
